import { gql } from "@apollo/client";

export const QUERY_GET_SYSTEMS_SITES_ORGANIZATIONS = gql`
    query SitesAndOrganizations {
        WaterSystems {
            select {
              id
              name
              site {
                id
                name
                country
                organization {
                  id
                  name
                  tier
                }
              }
            }
        }
    }
`

export const QUERY_GET_COUNTRIES = gql`
    query Countries {
        Sites {
            select {
              id
              name
              country
            }
        }
    }
`

export const QUERY_GET_REASONS = gql`
    query GetReasons {
        Reasons {
            select {
              id
              text
              confirmation
            }
        }
    }
`
export const QUERY_GET_ERRORS = gql`
  query GetErrors {
    Products(
      where: {
        AND: [
          {
            waterSystem: {
            	paying: { EQ: true },
              testUnit: { EQ: false }
          	}
          }
        ]
      }
    ) {
      select {
        id
        lastSms
        batStat
        lastDateBatteryIncrease
        lastDateBatteryDecrease
        moSensorIssue
        valveError
        valveErrorLastUpdate
        currentVersion
        hwId
        hwVerMajor,
        hwVerMinor,
        mqtt,
        disable
        enableFlag
        manualOveride
        manualOverideDate
        learningDate
        override
        actOnLeak
        valvePresence
        user {
          id
          firstName
          lastName
          cellPhoneCode
          cellPhone
        }
        waterSystem {
          id
          name
          ac
          valveType
          noWaterCount
          typeOfValve
          meterType
          valvePresence
          testUnit
          site {
            id
            name
            country
            address
            organization {
              id
              name
            }
          }
        }
      }
    }
  }
`

export const QUERY_GET_OPEN_LEAKS = gql`
query EventHistoryOpenLeaks {
    EventHistoryOpenLeaks {
      select {
        id
        eventData
        eventType
        innerType
        eventStatus
        siteCountry
        endedAt
        createdAt
        updatedAt
        salesforceId
        userId
        userFirstName
        userLastName
        valve
        valveError
        waterSystemId
        waterSystemName
        waterSystemValveType
        siteId
        siteCountry
        siteName
        orgId
        orgName
        orgTier
      }
    }
  }
`

export const QUERY_GET_CLOSED_LEAKS = gql`
  query EventHistoryClosedLeaks($date: SqlTimestamp!) {
    EventHistoryClosedLeaks(
      where: {
        AND: [
          { endedAt: { GT: $date } },
        ]
      }
    ) {
      select {
        id
        eventData
        eventType
        innerType
        eventStatus
        siteCountry
        endedAt
        createdAt
        updatedAt
        salesforceId
        userId
        userFirstName
        userLastName
        valve
        valveError
        waterSystemId
        waterSystemName
        waterSystemValveType
        siteId
        siteCountry
        siteName
        orgId
        orgName
        orgTier
      }
    }
  }
`

export const QUERY_WATER_SYSTEM_STATUSES = gql`
    query GetWaterSystemStatuses {
      WaterSystemStatuses {
        select {
          waterSystemId,
          waterSystemName,
          siteId,
          siteName,
          organizationId,
          organizationName,
          valveType,
          typeOfValve,
          policyId,
          policyName,
          policyType,
          policyData,
          hwId,
          innerType,
          valveStatus,
          valveError,
          powerSource
        }
      }
    }
`